import { Alert, AlertTitle, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CurrencyCard from "../components/utils/currencyCard.tsx";
import getReq from "../interface/getRequestinterface";
import postReq from "../interface/postRequestinterface";
import { getRequest, postRequest } from "../request";
import Loading from "./loading";

const listOfColors = {
  gold: "#ffd700",
  goldbtn: "#d3bd48",
  silver: "#C0C0C0",
  silverbtn: "#7f7f7f",
  bronze: "#CD7F32",
  bronzebtn: "#886644",
};

const style = {
  formTitle: {
    fontWeight: "bold !important",
  },
  formDescription: {
    color: "#9b9b9b",
  },
  formContainer: {
    padding: "1rem !important",
    border: "3px solid #748DA6",
    borderRadius: "10px",
    backgroundColor: "#f1f7ff59",
    height: "auto",
  },
  gridBox: {
    display: "grid",
    gridTemplateColumns: "30rem 30rem 30rem",
    columnGap: "2%",
    justifyContent: "space-around",
    marginTop: "2rem",
  },
  mobileGridBox: {
    display: "grid",
    gridTemplateColumns: "auto",
    // columnGap:'5%',
    // rowGap:'7%',
    justifyContent: "center",
    marginTop: "2rem",
  },
  tabletGridBox: {
    display: "grid",
    gridTemplateColumns: "25rem 25rem",
    columnGap: "5%",
    justifyContent: "center",
    marginTop: "2rem",
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    borderRadius: "3px",
    width: "30rem",
  },
  modalMobileStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    borderRadius: "3px",
    width: "15rem",
  },
  txtField: {
    width: "100%",
  },
  headerContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  stateHandler: {
    display: "flex",
    justifyContent: "center",
  },
  stateType: { fontWeight: "bold" },
  title: {
    display: "flex",
    justifyContent: "space-between",
    width: "65rem",
  },
  defineServices: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    width: "30rem",
    height: "80vh",
  },
  goldServiceBoxMobile: {
    // width:'100%',
    // padding:'0.5rem',
    // backgroundColor:listOfColors.gold+'a3',
    // border:`3px solid ${listOfColors.gold}`,
    // borderRadius:'0.3rem',
    // textAlign:'center'
    position: "relative",
    display: "inline-block",
  },
  silverServiceBoxMobile: {
    // width:'100%',
    // padding:'0.5rem',
    // backgroundColor:listOfColors.silver+'a3',
    // border:`3px solid ${listOfColors.silver}`,
    // borderRadius:'0.3rem',
    // textAlign:'center'
    position: "relative",
    display: "inline-block",
  },
  bronzeServiceBoxMobile: {
    // width:'100%',
    // padding:'0.5rem',
    // backgroundColor:listOfColors.bronze+'a3',
    // border:`3px solid ${listOfColors.bronze}`,
    // borderRadius:'0.3rem',
    // textAlign:'center'
    position: "relative",
    display: "inline-block",
  },
  goldServiceBox: {
    // width:'100%',
    // padding:'0.5rem',
    // background:`url('${require('../assets/image/goldenCard.png')}')`,
    // backgroundSize: 'cover',
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'center center',
    // border:`3px solid ${listOfColors.gold}`,
    // borderRadius:'0.3rem',
    position: "relative",
    display: "inline-block",
  },
  silverServiceBox: {
    // width:'100%',
    // padding:'0.5rem',
    // backgroundImage: `linear-gradient( ${listOfColors.silver}a3, ${listOfColors.silver}20)`,
    // border:`3px solid ${listOfColors.silver}`,
    // borderRadius:'0.3rem',
    position: "relative",
    display: "inline-block",
  },
  bronzeServiceBox: {
    // width:'100%',
    // padding:'0.5rem',
    // backgroundImage: `linear-gradient(${listOfColors.bronze}a3, ${listOfColors.bronze}6b)`,
    // border:`3px solid ${listOfColors.bronze}`,
    // borderRadius:'0.3rem',
    position: "relative",
    display: "inline-block",
  },
  goldServiceBtn: {
    backgroundColor: listOfColors.goldbtn,
  },
  silverServiceBtn: {
    backgroundColor: listOfColors.silverbtn,
  },
  bronzeServiceBtn: {
    backgroundColor: listOfColors.bronzebtn,
  },
  circleGold: {
    backgroundColor: "#ffe55c",
    borderRadius: "50%",
    padding: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-1.5rem",
    marginLeft: "-1rem",
    border: `3px solid ${listOfColors.gold}`,
  },
  circleSilver: {
    backgroundColor: "#d7d7d7",
    borderRadius: "50%",
    padding: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-1.5rem",
    marginLeft: "-1rem",
    border: `3px solid ${listOfColors.silver}`,
  },
  circleBronze: {
    backgroundColor: "#dfad7c",
    borderRadius: "50%",
    padding: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-1.5rem",
    marginLeft: "-1rem",
    border: `3px solid ${listOfColors.bronze}`,
  },
  insideCard: {
    position: "absolute",
    top: "47%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "25rem",
  },
  insideCardMobile: {
    position: "absolute",
    top: "47%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "22rem",
  },
};
interface CharenceService {
  id: number;
  isActive: boolean;
  level_Id: number;
  price_Service: string;
  title: string;
  type_Id: number;
}
interface CharenceUser {
  id: number;
  userId: number;
  user_name: string;
  service_Id: number;
  is_Select: boolean;
  is_Used: boolean;
  date_Select: string;
  date_Used: object;
  requested_ID: object;
}

function CostumerServicesList() {
  const [ListOfCharence_Users, setListOfCharence_Users] = useState<
    Array<CharenceUser>
  >([]);
  const [ListOfCharense_Services, setListOfCharense_Services] = useState<
    Array<CharenceService>
  >([]);
  const navigate = useNavigate();
  const userLevel = JSON.parse(
    localStorage.getItem("userLevel")!
  ).charense_level_ID;
  // _____________________________________________________________________________________________________________________________________
  useEffect(() => {
    handleGetListOfServices();
  }, []);
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });

  const handleGetListOfServices = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/User/Find_list_service_User`
    )) as getReq;
    if (!error) {
      setListOfCharence_Users(data.charence_Users);
      setListOfCharense_Services(data.charense_Services);
    }
  };
  const handleSelectService = async (serviceId, levelId) => {
    if (levelId <= parseInt(userLevel)) {
      const { data, error }: postReq = (await postRequest(
        `${process.env.REACT_APP_BASE_URL}/User/add_charencese_users?Service_ID=${serviceId}`
      )) as postReq;
      if (!error) {
        toast.success("خدمت مورد نظر با موفقیت انتخاب شد !");
        setTimeout(() => {
          navigate(0);
        }, 2000);
      }
    } else {
      toast.error(
        "امکان انتخاب این سرویس با توجه به سطح کاربری شما وجود ندارد!"
      );
    }
  };
  return (
    <div className="background">
      {ListOfCharense_Services.length ? (
        <div>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
            }}
          >
            <Alert severity="info" sx={{ width: "fit-content" }}>
              <AlertTitle sx={{ fontWeight: "bold", fontSize: "2rem" }}>
                لیست سرویس های موجود
              </AlertTitle>
            </Alert>
          </div>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <div
              onClick={() => navigate("/customerclub")}
              className="animated-button8"
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              راهنمای باشگاه مشتریان
            </div>
          </Box>
          <Box
            sx={
              isDesktop
                ? style.gridBox
                : isTablet
                ? style.tabletGridBox
                : style.mobileGridBox
            }
          >
            {ListOfCharense_Services.map((service) => (
              <CurrencyCard
                isDesktop={isDesktop}
                disableSelectBtn={false}
                service={service}
                handleSelectService={handleSelectService}
                ListOfCharence_Users={ListOfCharence_Users}
              />
            ))}
          </Box>
        </div>
      ) : (
        <div
          style={{
            width: "100vw",
            height: "calc( 100vh - 64px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading type="cylon" color="#000" />
        </div>
      )}
    </div>
  );
}

export default CostumerServicesList;
